<template>
  <va-card class="flex mb-4">
    <va-card-title style="height: 30px;padding:5px;padding-left:20px ">许可审批<span v-if="isShowEditRow">—— 许可数量：共{{ allLicense }} 已使用{{ hasUsedLicense }} 剩余<span
      style="color:green;font-weight: bold;font-size: 14px">{{ remainLicense }}</span></span> </va-card-title>
    <va-card-content>
      <div>
        <div>
          <vxe-form :data="toolbar.formData">
            <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
              <template #default="{ data }">
                <vxe-input v-model="data.searchKey" placeholder="请输入姓名或邮箱"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item>
              <template #default>
                <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
                <vxe-button @click="clear">重置</vxe-button>

              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
        <div style="overflow: hidden;height: 100%">
          <vxe-table
            class="mytable-scrollbar"
            :data="tableData"
            :height="tableHeight"
            show-overflow
            :row-config="{height: 36,isHover: true,isCurrent:true}"
           >
            <vxe-column type="seq" field="Id" title="序号" width="60"></vxe-column>
            <vxe-column align="center" title="审批" width="100" show-overflow>
              <template #default="{ row }">
                <vxe-button status="success" icon="fa fa-check" round @click="auditRowEvent(row)">审批</vxe-button>
              </template>
            </vxe-column>
            <vxe-column align="center" title="状态" width="100">
              <template #default="{row}">
                <vxe-button type="text" @click="showAuditList(row)">{{ row.statusName }}</vxe-button>
              </template>
            </vxe-column>
            <vxe-column field="applyType" title="申请类型" width="100" sortable></vxe-column>
            <vxe-column field="licenseStatus" title="许可状态" width="100" sortable></vxe-column>
            <vxe-column field="userName" title="姓名" width="100" sortable></vxe-column>
            <vxe-column field="emailEx" title="邮箱" width="180" sortable resizable show-overflow></vxe-column>
            <vxe-column field="jobNumber" title="工号" width="100" sortable></vxe-column>
            <vxe-column field="headQuarter" title="总部（英文代码）" width="160" sortable></vxe-column>
            <vxe-column field="dept" title="部门（英文代码）" width="160" sortable></vxe-column>
            <vxe-column field="office" title="科室" width="100" sortable></vxe-column>
            <vxe-column field="planFinishTime" title="预计完成开发时间" width="160"></vxe-column>
            <vxe-column field="licenseStartTime" title="许可启用时间" width="140"></vxe-column>
            <vxe-column field="licenseEndTime" title="许可停用时间" width="140"></vxe-column>
            <vxe-column field="flowName" title="待开发的RPA流程名称" width="200" resizable></vxe-column>
            <vxe-column field="sceneDesc" title="RPA场景描述" width="220" show-overflow="ellipsis" resizable></vxe-column>
            <vxe-column field="singleTimeUse" title="流程单次耗时(小时)" width="180"></vxe-column>
            <vxe-column field="frequency" title="流程执行频次（N次/每月）" width="200"></vxe-column>
            <vxe-column field="participate" title="流单次参与人员" width="140"></vxe-column>
            <vxe-column field="yearTimeUse" title="全年预计耗时(小时/年)" width="200"></vxe-column>
            <vxe-column field="creationTime" title="创建时间" width="120" sortable></vxe-column>
          </vxe-table>
        </div>
        <div>
          <vxe-pager
            background
            v-model:current-page="tablePager.currentPage"
            v-model:page-size="tablePager.pageSize"
            :total="tablePager.totalResult"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
          </vxe-pager>
        </div>
      </div>

      <vxe-modal
        v-model="formInput.isShow"
        @close="closeWinEvent"
        :title="formInput.title"
        width="900" height="600"
        show-zoom resize remember>
        <template #default>
          <vxe-form
            :data="formInput.formData"
            :rules="formInput.formRules"
            title-align="right"
            ref="rForm"
            title-width="60">
            <vxe-form-item title="基本信息" span="24" title-align="left" title-width="200px"
              :title-prefix="{icon: 'fa fa-address-card-o'}"></vxe-form-item>
            <vxe-form-item title="姓名" field="userName" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.userName" placeholder="请输入姓名"
                  :disabled="formInput.allInputDisable" readonly></vxe-input>
              </template>
            </vxe-form-item>

            <vxe-form-item title="邮箱" field="emailEx" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.emailEx" placeholder="请输入邮箱"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工号" field="jobNumber" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.jobNumber" placeholder="请输入工号" clearable
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="总部(英文代码)" field="headQuarter" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.headQuarter" readonly placeholder="请输入总部(英文代码)"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="部门(英文代码)" field="dept" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.dept" readonly placeholder="请输入部门(英文代码)"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="科室" field="office" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.office" placeholder="请输入科室"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="待开发的RPA流程名称" field="flowName" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.flowName" placeholder="请输入待开发的RPA流程名称"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>

            <vxe-form-item title="预计完成开发时间" field="applyMonth" span="12" title-width="160px">
              <template #default>
                <vxe-select v-model="formInput.formData.applyMonth" placeholder="请选择预计完成开发时间" clearable
                  :disabled="formInput.allInputDisable">
                  <vxe-option value="1" label="1个月"></vxe-option>
                  <vxe-option value="2" label="2个月"></vxe-option>
                  <vxe-option value="3" label="3个月"></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="RPA场景描述" field="sceneDesc" span="24" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.sceneDesc" placeholder="请输入RPA场景描述"
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="流程单次耗时(小时)" field="singleTimeUse" span="12" title-width="160px">
              <template #default>
                <vxe-input type="number" v-model="formInput.formData.singleTimeUse" placeholder="请输入流程单次耗时(小时)"
                  :disabled="formInput.allInputDisable"
                  @change="calYearUse" min="0" clearable></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="流程执行频次(N次/每月)" field="frequency" span="12" title-width="180px">
              <template #default>
                <vxe-input v-model="formInput.formData.frequency" placeholder="请输入流程执行频次" clearable
                  :disabled="formInput.allInputDisable" type="number" min="0"
                  @change="calYearUse"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="单次参与人员" field="participate" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.participate" placeholder="请输入单次参与人员" clearable
                  :disabled="formInput.allInputDisable" type="number" min="0"
                  @change="calYearUse"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="全年预计耗时(小时/年)" field="yearTimeUse" span="12" title-width="180px">
              <template #default>
                <vxe-input v-model="formInput.formData.yearTimeUse" placeholder="请输入全年预计耗时" readonly
                  :disabled="formInput.allInputDisable" type="number" min="0"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="直属领导" field="leader" span="12" title-width="160px">
              <template #default>
                <vxe-input v-model="formInput.formData.leader" placeholder="请输入直属领导" clearable
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="领导邮箱" field="leaderEmail" span="12" title-width="180px">
              <template #default>
                <vxe-input v-model="formInput.formData.leaderEmail" placeholder="请输入领导邮箱" clearable
                  :disabled="formInput.allInputDisable"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item span="24">
              <template #default>
                <vxe-textarea rows="4" v-model="auditOpinion" placeholder="请输入审核意见" maxlength="1000"
                  show-word-count></vxe-textarea>
              </template>
            </vxe-form-item>
            <vxe-form-item align="center" span="24" style="position: absolute;bottom: 0">
              <template #default>
                <vxe-button
                  @click="reject"
                  icon="fa fa-reply"
                  status="danger">驳回
                </vxe-button>
                <vxe-button
                  @click="submit"
                  icon="fa fa-check"
                  status="success">通过
                </vxe-button>
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
      </vxe-modal>
      <vxe-modal title="审核记录" v-model="isShowAuditList" width="500" height="600">
        <template #default>
          <div>
            <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
          </div>
        </template>
      </vxe-modal>
    </va-card-content>
  </va-card>
</template>

<script>
import Qs from 'qs'
import {reactive, ref} from 'vue';
import {VxeTablePropTypes} from "vxe-table";
import {VXETable} from 'vxe-table'
import XEUtils from 'xe-utils'
import MyAuditLine from "../myPlug/MyAuditLine";


export default {
  name: "LicenseAudit",
  components: {MyAuditLine},
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    const auditOpinion = ref('OK')
    const formInput = reactive({
      title: '许可申请审批',
      isShow: false,
      saveButDisable: false,
      allInputDisable: false,
      formData: {
        Id: '',
        userName: '',
        emailEx: '',
        jobNumber: '',
        headQuarter: '',//总部
        dept: '',//部门
        office: '',//科室
        flowName: '',
        planFinishTime: '',
        applyMonth: '',
        sceneDesc: '',
        singleTimeUse: '',
        frequency: '',
        participate: '',
        yearTimeUse: '',
        leader: '',
        leaderEmail: '',
        status: ''

      },
      formRules: {
        userName: [
          {required: true, message: '姓名不能为空'},
        ],
        emailEx: [
          {required: true, message: '邮箱不能为空'}
        ],
        jobNumber: [
          {required: true, message: '工号不能为空'}
        ],
        headQuarter: [
          {required: true, message: '总部(英文代码)不能为空'}
        ],
        dept: [
          {required: true, message: '部门(英文代码)不能为空'}
        ],
        office: [
          {required: true, message: '科室不能为空'}
        ],
        flowName: [
          {required: true, message: '待开发的RPA流程名称不能为空'}
        ],
        applyMonth: [
          {required: true, message: '预计完成开发时间不能为空'}
        ],
        sceneDesc: [
          {required: true, message: 'RPA场景描述不能为空'}
        ],
        singleTimeUse: [
          {required: true, message: '流程单次耗时(小时)不能为空'}
        ],
        frequency: [
          {required: true, message: '流程执行频次(N次/每月)不能为空'}
        ],
        participate: [
          {required: true, message: '单次参与人员不能为空'}
        ],
        yearTimeUse: [
          {required: true, message: '全年预计耗时(小时/年)不能为空'}
        ],
        leader: [
          {required: true, message: '直属领导不能为空'}
        ],
        leaderEmail: [
          {required: true, message: '领导邮箱不能为空'}
        ],
      }
    })
    return {
      tableData: null,
      tablePager,
      toolbar,
      pageHeight,
      formInput,
      dtAudit: [],
      isShowAuditList: false,
      auditOpinion,
      isShowEditRow: false,
      hasUsedLicense: 0, //已经使用许可
      allLicense: 0, //许可总是
      remainLicense: 0,
      tableHeight: 0
    }
  },
  methods: {
    launchToast(toastMsg) {
      this.$vaToast.init({
        message: toastMsg,
        iconClass: this.toastIcon,
        position: this.toastPosition,
        duration: Number(this.toastDuration),
        fullWidth: this.isToastFullWidth,
      })
    },
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.licenseManageAPI.getLicenseAudit(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);
        })
        .catch(error => {
          console.log(error);

        })
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36+22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    auditRowEvent(row) {

      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.Id]
      };

      this.$api.licenseManageAPI.getOneLicense(Qs.stringify(params))
        .then(res => {
          if (res.data.Success === false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.formData = res.data.Data;
          this.auditOpinion = 'OK';
          this.formInput.allInputDisable = true;
          this.formInput.saveButDisable = true;
          this.formInput.isShow = true;

        })
        .catch(error => {
          console.log(error);

        })
    },
    showAuditList(row) {

      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 1,
        'searchKey': [row.Id] //
      };
      this.$api.requireManageAPI.getAuditRecordList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.dtAudit = res.data.Data;
          this.isShowAuditList = true;
        })
        .catch(error => {
          console.log(error);

        })

    },
    addAuditRecord(status) {
      //写审核日志
      const params = {
        'auditBuId': this.formInput.formData.Id,
        'auditMan': this.$store.state.userName,
        'auditManUid': this.$store.state.userID,
        'auditStatus': status,//0发起 1 通过 2 驳回
        'auditOpinion': this.auditOpinion,
        'auditNode': ''
      };
      this.$api.requireManageAPI.addAuditRecord(Qs.stringify(params))
        .then(res => {
          if (res.data.Success === false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }

        })
        .catch(error => {
          console.log(error);
        })
    },
    //驳回
    async reject() {
      if (this.auditOpinion === 'OK') {
        VXETable.modal.message({content: "驳回请修改默认审核意见", status: 'error'});
        return;
      }
      const type = await VXETable.modal.confirm('您确定要驳回吗?')

      if (type === 'confirm') {

        this.$api.licenseManageAPI.auditLicense(Qs.stringify({licenseId: this.formInput.formData.Id, editType: '1',userId: this.$store.state.userID}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            this.findData();
            //审核记录
            this.addAuditRecord('2'); //2 驳回

            VXETable.modal.message({content: "驳回成功", status: 'success'});
            this.formInput.isShow = false;

          })
          .catch(error => {
            console.log(error);
          })

      }
    },
    //提交
    submit() {

      if (this.auditOpinion === '') {
        VXETable.modal.message({content: "审核意见不能为空", status: 'error'});
        return;
      }
      const param = {
        licenseId: this.formInput.formData.Id,
        editType: '2',
        userId: this.$store.state.userID
      }

      this.$api.licenseManageAPI.auditLicense(Qs.stringify(param))
        .then(res => {
          if (res.data.Success === false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({content: '审批成功', status: 'success'});
          this.findData();
          this.addAuditRecord('1');//1 通过
          this.formInput.isShow = false;
        })
        .catch(error => {
          VXETable.modal.message({content: error, status: 'error'});
          console.log(error);
        });


    },
    getLicenseCount() {
      this.$api.licenseManageAPI.getLicenseCount()
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.allLicense = res.data.Data.AllCount;
          this.hasUsedLicense = res.data.Data.UsedCount;
          this.remainLicense = res.data.Data.RemainCount;

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
    clear() {
      this.toolbar.formData.searchKey = ''
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    }
  },
  created() {
    this.isShowEditRow = this.$store.state.isAdmin === '1';
  },
  mounted() {
    this.findData();
    this.getLicenseCount();
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  }
}
</script>

<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
